import { ChangeDetectionStrategy, Component, inject, OnInit, signal } from '@angular/core';
import { ProductService } from '../../services/product.service';
import { onWindowLoad } from '../../helpers/on-window-load.function';
import { ProductsPreviewComponent } from '../products-preview/products-preview.component';
import { CartModalComponent, CartModalData } from '../cart-modal/cart-modal.component';
import { MatDialog } from '@angular/material/dialog';

@Component({
  selector: 'recently-viewed-products',
  templateUrl: './recently-viewed-products.component.html',
  styleUrls: ['./recently-viewed-products.component.scss'],
  imports: [ProductsPreviewComponent],
  host: { '[class.is-empty]': '!recentlyViewedProducts()?.length' },
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class RecentlyViewedProductsComponent implements OnInit {
  private productService = inject(ProductService);
  private dialog = inject(MatDialog);

  recentlyViewedProducts = signal<number[] | undefined>(undefined);
  protected readonly sourceForAnalytics = 'recently_viewed_products';

  ngOnInit(): void {
    onWindowLoad(() => this.init());
  }

  /**
   * Re-reads the list, for a page that is being shown again rather than built. The ids live
   * in local storage and every product visited since this page was cached has been pushed in
   * front of them, so without this the strip would still be advertising the way the shop
   * looked on the way out — and it is the strip the whole round trip is usually made from.
   */
  refresh(): void {
    this.init();
  }

  showCart(_productId: number): void {
    this.dialog.open<CartModalComponent, CartModalData>(
      CartModalComponent,
      { data: { sourceForAnalytics: this.sourceForAnalytics } },
    );
  }

  private init(): void {
    this.recentlyViewedProducts.set(this.productService.getViewedProductsFromLocalStorage());
  }
}
